import React, { useContext, useEffect } from "react";
import { Modal, Input, Button } from "@material-ui/core";
import { StoreContext } from './pedidosContext/Store'

const ModalTimer = props => {
    const [minutos, setMinutos] = React.useState(0);

    const { state, dispatch } = useContext(StoreContext);

    useEffect(() => {
        dispatch({
            type: 'MODIFYING',
            dirty: 1
        });

        return () => dispatch({
            type: 'MODIFYING',
            dirty: 0
        });
    }, [])

    const setTimestamp = () => {
        props.setTimestamp(minutos);
        props.setShowModal(false);

    };
    const close = () => {
        props.setShowModal(!props.showModal);
    };
    return (
        <Modal
            open={props.showModal}
            onClose={() => close()}
            className="modalContainer"
        >
            <div className="modalBody">
                <p>Ingresa los minutos:</p>
                <Input
                    type="string"
                    value={minutos}
                    onChange={e => setMinutos(e.target.value)}
                ></Input>
                <Button
                    variant="outlined"
                    className="btnVerificar"
                    onClick={() => setTimestamp()}
                >
                    Aceptar
                </Button>
            </div>
        </Modal>
    );
};

export default ModalTimer;
